import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { CASH } from '@makemydeal/dr-platform-types';

import { PaymentGridOffNote } from '../../../ScenarioGrid.style';
import { ScenarioRow } from '../../ScenarioRow';

export const PAYMENT_GRID_OFF_TEXT = 'Payment Grid is off';
export const PAYMENT_GRID_NOT_APPLICABLE_TEXT = 'Payment Grid not applicable';

export const PaymentGridOffRow = () => {
    const theme = useInterstateTheme();
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);

    return (
        <ScenarioRow rowKey="paymentGrid">
            <PaymentGridOffNote theme={theme} role="note" data-testid="scenario-row-paymentGrid-off">
                {offerType === CASH ? PAYMENT_GRID_NOT_APPLICABLE_TEXT : PAYMENT_GRID_OFF_TEXT}
            </PaymentGridOffNote>
        </ScenarioRow>
    );
};
